// biome-ignore lint/style/noRestrictedImports: app root, ContextProviders provides the theme
import { createRoot } from 'react-dom/client';

import App from './App';
import './styles/index.css';

import { initI18n } from './i18n';
import { initMixpanel } from './mixpanel';
import { reloadOnStaleChunk } from './reloadOnStaleChunk';

/**
 * Vite fires this event when any dynamic import fails to load (404, SyntaxError, etc.).
 * @see https://vite.dev/guide/build#load-error-handling
 */
window.addEventListener('vite:preloadError', () => {
  reloadOnStaleChunk();
});

if (import.meta.env.DEV) {
  const { loadDevMessages, loadErrorMessages } = await import(
    '@apollo/client/dev'
  );
  loadDevMessages();
  loadErrorMessages();
}

// Load the active language's translations BEFORE the first render so no UI
// paints raw keys (GF-204). Translations are no longer bundled in the main
// chunk — initI18n() pulls the active language's local chunk on demand.
await initI18n();

void initMixpanel();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
